// Zmniejsza i kompresuje wgrany obraz do data-URL o ograniczonym rozmiarze.
// Tła motywów Biurka są zapisywane w localStorage jako data-URL; surowe zdjęcie
// z aparatu (kilka–kilkanaście MB) potrafiło samodzielnie wyczerpać limit
// localStorage (~5 MB), co blokowało m.in. zapis stanu logowania OIDC. Skalujemy
// do rozsądnego maksimum i kompresujemy do JPEG, więc tło zajmuje dziesiątki KB.
export async function downscaleImageToDataUrl(
  file: File,
  maxDim = 1920,
  quality = 0.82,
): Promise<string> {
  const dataUrl = await new Promise<string>((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result));
    r.onerror = () => reject(r.error);
    r.readAsDataURL(file);
  });

  // GIF (animacja) i SVG (wektor) — kanwowanie zniszczyłoby je; zwróć oryginał.
  if (file.type === "image/gif" || file.type === "image/svg+xml") return dataUrl;

  const img = await new Promise<HTMLImageElement>((resolve, reject) => {
    const i = new Image();
    i.onload = () => resolve(i);
    i.onerror = () => reject(new Error("Nie udało się wczytać obrazu"));
    i.src = dataUrl;
  });

  const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
  // Już mały i bez potrzeby skalowania — nie przekodowuj.
  if (scale === 1 && dataUrl.length < 1_500_000) return dataUrl;

  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(img.width * scale));
  canvas.height = Math.max(1, Math.round(img.height * scale));
  const ctx = canvas.getContext("2d");
  if (!ctx) return dataUrl;
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL("image/jpeg", quality);
}
